import { Skeleton } from "../ui/skeleton";

export default function RoomSkeleton() {
  return (
    <div className="grow flex p-3 flex-col  w-full">
      <div className="grow grid grid-cols-1 xs:grid-cols-2 gap-2">
        <Skeleton className="w-full h-full" />
        <Skeleton className="w-full h-full" />
        <Skeleton className="w-full h-full" />
        <Skeleton className="w-full h-full" />
      </div>
      <div className=""></div>
    </div>
  );
}
